import { initializeApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const DEFAULT_RECAPTCHA_CONTAINER = 'recaptcha-container';

const auth = getAuth(app);

if (process.env.NODE_ENV !== 'production' && auth.settings) {
  auth.settings.appVerificationDisabledForTesting = true;
}

const clearRecaptchaVerifier = () => {
  if (window.recaptchaVerifier) {
    window.recaptchaVerifier.clear();
    window.recaptchaVerifier = null;
  }
};

const createRecaptchaVerifier = (containerId = DEFAULT_RECAPTCHA_CONTAINER) => {
  if (window.recaptchaVerifier) {
    return window.recaptchaVerifier;
  }

  const container = document.getElementById(containerId);
  if (container) {
    container.innerHTML = '';
  }

  window.recaptchaVerifier = new RecaptchaVerifier(
    auth,
    containerId,
    {
      size: 'normal',
    },
  );

  return window.recaptchaVerifier;
};

export { auth, clearRecaptchaVerifier, createRecaptchaVerifier };
